var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "制卡",
        visible: _vm.visible,
        width: "480px",
        "custom-class": "make-card-dialog",
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
        close: _vm.handleClose,
      },
    },
    [
      _c(
        "el-form",
        {
          ref: "makeCardForm",
          staticClass: "make-card-form",
          attrs: {
            model: _vm.formData,
            rules: _vm.rules,
            "label-width": "120px",
            size: "small",
          },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "卡面名称：", prop: "cardFaceName" } },
            [
              _c("el-input", {
                attrs: {
                  maxlength: "50",
                  placeholder: "请输入",
                  clearable: "",
                },
                model: {
                  value: _vm.formData.cardFaceName,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "cardFaceName", $$v)
                  },
                  expression: "formData.cardFaceName",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "可用小程序：", prop: "availableProgram" } },
            [
              _c(
                "el-select",
                {
                  staticClass: "dialog-input",
                  attrs: {
                    placeholder: "请选择",
                    clearable: "",
                    filterable: "",
                  },
                  model: {
                    value: _vm.formData.availableProgram,
                    callback: function ($$v) {
                      _vm.$set(_vm.formData, "availableProgram", $$v)
                    },
                    expression: "formData.availableProgram",
                  },
                },
                _vm._l(_vm.programOptions, function (item) {
                  return _c("el-option", {
                    key: item.id,
                    attrs: { label: item.appName, value: String(item.id) },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "制作数量：", prop: "totalCount" } },
            [
              _c("el-input", {
                attrs: { placeholder: "请输入", clearable: "" },
                model: {
                  value: _vm.formData.totalCount,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "totalCount", $$v)
                  },
                  expression: "formData.totalCount",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "卡面正面样式：", prop: "frontStyleUrl" } },
            [
              _c("div", { staticClass: "image-upload-row" }, [
                _c(
                  "div",
                  {
                    staticClass: "image-upload-box",
                    on: {
                      click: function ($event) {
                        return _vm.triggerImageSelect("front")
                      },
                    },
                  },
                  [_c("i", { staticClass: "el-icon-upload2" })]
                ),
                _vm._v(" "),
                _vm.formData.frontStyleUrl
                  ? _c(
                      "div",
                      {
                        staticClass: "image-preview-box",
                        on: {
                          click: function ($event) {
                            return _vm.triggerImageSelect("front")
                          },
                        },
                      },
                      [
                        _c("img", {
                          attrs: { src: _vm.formData.frontStyleUrl, alt: "" },
                        }),
                        _vm._v(" "),
                        _c("i", {
                          staticClass: "el-icon-circle-close image-remove",
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              return _vm.removeImage("front")
                            },
                          },
                        }),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("input", {
                  ref: "frontImageInput",
                  staticClass: "hidden-file-input",
                  attrs: { type: "file", accept: "image/*" },
                  on: {
                    change: function ($event) {
                      return _vm.handleImageChange($event, "front")
                    },
                  },
                }),
              ]),
            ]
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "卡面背面样式：", prop: "backStyleUrl" } },
            [
              _c("div", { staticClass: "image-upload-row" }, [
                _c(
                  "div",
                  {
                    staticClass: "image-upload-box",
                    on: {
                      click: function ($event) {
                        return _vm.triggerImageSelect("back")
                      },
                    },
                  },
                  [_c("i", { staticClass: "el-icon-upload2" })]
                ),
                _vm._v(" "),
                _vm.formData.backStyleUrl
                  ? _c(
                      "div",
                      {
                        staticClass: "image-preview-box",
                        on: {
                          click: function ($event) {
                            return _vm.triggerImageSelect("back")
                          },
                        },
                      },
                      [
                        _c("img", {
                          attrs: { src: _vm.formData.backStyleUrl, alt: "" },
                        }),
                        _vm._v(" "),
                        _c("i", {
                          staticClass: "el-icon-circle-close image-remove",
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              return _vm.removeImage("back")
                            },
                          },
                        }),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("input", {
                  ref: "backImageInput",
                  staticClass: "hidden-file-input",
                  attrs: { type: "file", accept: "image/*" },
                  on: {
                    change: function ($event) {
                      return _vm.handleImageChange($event, "back")
                    },
                  },
                }),
              ]),
            ]
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "备注：" } },
            [
              _c("el-input", {
                attrs: {
                  type: "textarea",
                  rows: 4,
                  maxlength: "500",
                  placeholder: "请输入",
                },
                model: {
                  value: _vm.formData.remark,
                  callback: function ($$v) {
                    _vm.$set(_vm.formData, "remark", $$v)
                  },
                  expression: "formData.remark",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              attrs: { size: "small" },
              on: {
                click: function ($event) {
                  _vm.visible = false
                },
              },
            },
            [_vm._v("取消")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              attrs: {
                size: "small",
                type: "primary",
                loading: _vm.submitLoading,
              },
              on: { click: _vm.debouncedSubmit },
            },
            [_vm._v("确定")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }